/**
 * Adds properties to an existing component,
 * making it possible to compose a component with
 * different behavior.
 *
 * @param constructComponent
 * @param composeProps
 * @returns {function()}
 */
export default function compose(constructComponent, composeProps = {}) {
    return (props = {}) => {
        return constructComponent(Object.assign(composeProps, props));
    };
}
//# sourceMappingURL=compose.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/compose.js
// module id = 27
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11